<template>
    <div>
        <el-row v-for="(row, r) in rows" :key="`row_${r}`">
            <el-col v-for="(col, c) in row" :key="`col_${c}`" :span="col.attr.col">

                <ul :class="['formularioHorizontal']" >
                    <li>
                        
                        <div v-if="r == 0" :class="['form-label', 'ellipsis','visible-label', col.title_align ? `align_${col.title_align}` : 'align_left']">
                            <p class="ellipsis">
                                <span class="title">{{col.title}}</span>
                            </p>
                        </div>
                    
                        <div class="form-input">
                            <div style="height: 30px">

                                <div class="actions">

                                    <component
                                        :is="inputsTypeGoId.includes(col.format) ? col.format : 'Input'"

                                        :ref="['botongo','botonid'].includes(col.format) ? false : 'input'"
                                        :input="col"

                                        :placeholder="col.title"

                                        :readonly="col.state == 'read-only'"
                                        :type="col.format || 'text'"
                                        :required="!!col.obligatorio"
                                        
                                        v-model="col.value"

                                        outputFormat="DD/MM/YYYY"
                                        dateFormat="YYYY-MM-DD"

                                        :add2List="add2List(col)"
                                        :saveObject="saveObject"
                                        :saveFunction="saveFunction(col)"
                                        :get-list="urlLista(col)"
                                        :listObject="objetoLista(col)"
                                        :normal="!autosave"
                                        
                                        :textPre="col.textpre"
                                        :textPos="col.textpos"

                                        :siblings="inputList"

                                        @input="val => $emit('input', {newvalue: val, col})"
                                        @saved="val => $emit('saved', val)"

                                        @setActionId="setActionId"
                                    />
                                </div>

                            </div>
                        </div>    

                    </li>
                </ul>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Input from '@/components/inputs/Input.vue'

    import InputGo from '@/components/inputs/InputGo.vue'
	import InputId from '@/components/inputs/InputId.vue'
	import InputButtonGo from '@/components/inputs/InputButtonGo.vue'
    import InputButtonId from '@/components/inputs/InputButtonId.vue'
    
    import { createValorLista, getSelectInput, updateInput, updateInputFile } from '@/helpers/api'

    import merge from 'deepmerge'

	export default {
        name: 'FormularioHorizontal',
        components: {
            Input,
            botongo: InputButtonGo,
            botonid: InputButtonId,
            id: InputId,
            go: InputGo
        },
		props: {
            ficha: {
                type: Object,
                required: false,
                default: () => null
            },
            entidad: String,
            url: {
                type: Object,
                required: false,
                default: () => null
            },
            objects: {
                type: Array,
                required: false,
                default: () => null
            },
            id: String,
            autosave: {
                type: Boolean,
                required: false,
                default: () => true
            },
            divider: {
				type: Boolean,
				required: false,
				default: () => true
            },
            focus: {
				type: Boolean,
				required: false,
				default: () => false
            },
            inputList: Array,
            visibleLabel: {
                type: Boolean,
                required: false,
                default: () => true
            },
            porlet: Object
        },
		data () {
            return {
                estructura: null,
                currentAction: null,
                fichaInicial: null,
                formularioInicial: null,
                loading: false,
                inputsTypeGoId: ['id','go','botongo','botonid'],
                temporalData: {
                    "lineas_factura": [
                        {
                            "__tiporiesgo": {
                                "value": "a1"
                            },
                            "__comentariofacturaventa": {
                                "value": "a2"
                            }
                        },
                        {
                            "__tiporiesgo": {
                                "value": "b1"
                            },
                            "__comentariofacturaventa": {
                                "value": "b2"
                            }
                        },
                        {
                            "__tiporiesgo": {
                                "value": "c1"
                            },
                            "__comentariofacturaventa": {
                                "value": "c2"
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            rows() {
                // Generar filas
                let estructura = this.objects[0].estructura // Obtengo estructura
                let filas = Object.keys(this.objects[0]).filter(f => !!~f.search('f')) // Obtengo filas (La tengo en la segunda peticion)

                let rows = []
                filas.forEach(key_row => {

                    let cols = []
                    Object.keys(this.objects[0][key_row]).forEach(key_col => {
                        cols.push({
                            key: key_col,
                            ...merge(estructura[key_col],this.objects[0][key_row][key_col])
                        })
                    }, this)
                    rows.push(cols)

                }, this)
                
                return rows
            }
        },
        /*watch: {
            objects: {
                handler() {
                    this.init()
                },
                deep: true
            }
        },*/
        mounted() {
            //this.init()
            this.$emit('created')
        },
        methods: {

            init () {
                
                // Si hay url realizamos peticion de lo contrario creamos estructura con los objetos que puedan llegar
                if (this.url) {

                    this.loading = true

                    try {

                        // Hacer merge de peticiones, la de por defecto y la final con lo que hay que pintar definitivamente
                        this.fichaInicial = form
                        this.formularioInicial = Object.keys(form.data).map(key => {
                            const el = form.data[key]
                            return (typeof el == 'object') ? el : ''
                        }).filter(el => el !== '')

                    } catch (e) {
                        console.log('Error init :: ',e)
                    }

                    this.loading = false

                } else if (this.objects) {
                    
                    this.fichaInicial = this.ficha
                    this.formularioInicial = this.objects
                }

                this.crearEstructura()

                let _self = this
                setTimeout(() => {
                    //_self.createInputList() // Crea un listado de los input del formulario

                    if (_self.focus) { // primer elemento del formulario editable
                    console.log( _self.inputList)
                        _self.inputList[0].editing = true
                    }
                },100)

            },

            crearEstructura() {

                const salida = []
				let controlKey = 0
				this.formularioInicial.forEach((object, i) => {
					if(controlKey == 0 || ( controlKey < i )) { 

						const array = []

						if(!object.attr.hasOwnProperty('divider') || ( object.attr.hasOwnProperty('divider') && object.attr.divider)) {
							array.push(this.formularioInicial[controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + i : (i + 1) )]) // Hay divider, termina la fila
							controlKey = 0
						} else {

							let totalCol = 0 //Acumula el ancho de cada columna por fila recorrida
							while(totalCol < 24) { // Comprueba si hay hueco para meter mas campos

								controlKey = controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + (((totalCol>0 && totalCol<24) && i==0 )?i+1 : i) : (i + 1) ) // Almaceno el siguiente indice a recorrer
								const currentCol = (this.formularioInicial[controlKey].attr.col || 24)
								if((totalCol + currentCol) <= 24) { // Comprobar limite de columnas para cada fila
                                    
									array.push(this.formularioInicial[controlKey])
                                    totalCol = totalCol + currentCol
									
								} else {
									totalCol = 24
									controlKey = controlKey - 1
								}
							}
						}

						salida.push(array)

					} else if (controlKey == i) {
						controlKey = 0
					}
				})

                this.estructura = salida
                
            },

            saveFunction (dato) {
                if (dato.format == 'file') {
                    return data => {
                        return updateInputFile(data, {
                            id: this.id,
                            entidad: this.entidad,
                            field: dato.key,
                        })
                    }
                } else {
                    return data => updateInput({
                        id: this.id,
                        entidad: this.entidad,
                        field: dato.key,
                        ...data
                    })
                }
            },

            saveObject(val,comp) {
                if (typeof val == 'object') {
                    let formData = new FormData();
                    formData.append("image", val);
                    return formData
                } else {
                    return { newvalue: val }
                }
            },

            add2List (dato) {

				if (dato.tipo__id !== 5) return ''

				return () => createValorLista(dato.enlace)

            },

            urlLista (input) {
                
				if (input.formar !== "select") return () => getSelectInput(input.entidad)

            },
            
            objetoLista (dato) {

				if (dato.tipo__id !== 8) return val => ({ text: val, value: val })

				return val => ({ text: val.descripcion, value: val.descripcion })

			}, 
			
			// Unir propiedades dentro del mismo array Ej: CP/PAIS/PROVINCIA
			unionProps(data) {
				return data.reduce((a,d) => {
					if(d.title2 && !a.includes(d.title2)) {
						a.push(d.title2)
					}
					return a
				},[]).join(' / ')
            },
            
            // Obtener acciones para un determinado input
			getActionsByInput(input) {
                let actions = Object.keys(this.fichaInicial.actions).map(i => {
                    return this.fichaInicial.actions[i]
                })
				return actions.filter(el => {
					return input.actions.includes(el.type) 
				})
            },

            // Tratar accion
            /*setCurrentAction(action, input) {
                this.$emit('setCurrentAction', {action,input})
            },*/
            setActionId(input) {
                this.$emit('setActionId', input)
            }
        }
	}
</script>

<style lang="scss">
ul.formularioHorizontal {
    padding: 0px;
    margin: 0px;
    list-style: none;
    background-color: white;
    display: flex;
    &.divider {
        li{
            padding: 0rem;
        }
    }
    li {
        padding: 0rem;
        flex-flow: column;
        width: -webkit-fill-available;
        &.no-visible {
            display: none;
        }
        &.visible {
            display: flex;
        }
        * {
            border-radius: 0px!important;
        }
        .form-label {
            width: 100%;
            flex-shrink: 0;
            display: none;
            &.center {
                align-items: center;
            }
            &.visible-label {
                display: flex;
                padding: 10px;
                background-color: whitesmoke;
                width: -webkit-fill-available;
                font-weight: 700;
            }
            &.align_left {
                p {
                    text-align: left;
                }
            }
            &.align_right {
                p {
                    text-align: right;
                }
            }
            &.align_center {
                p {
                    text-align: center;
                }
            }
            p {
                font-size: .7rem;
                text-transform: uppercase;
                margin: 0px;
                width: 100%;
                .title-alt {
                    color: #4a596ab3;
                    margin-left: 0.3rem;
                    &:first-child {
                        margin-left: 1rem;
                    }
                }
            }
            span {
                    &.subtitle {
                    font-size: 0.7rem;
                    color: #4a596a;
                }
            }
        }
        .form-input {
            flex-grow: 1;
            .el-col {
                &.height-fit {
                    height: fit-content!important;
                }
            }
        }
        .actions {
            display: flex;
            height: auto;
            align-items: center;
            .actions-content {
                display: flex;
                flex-grow: 1;
                .action-button {
                    padding: 0px;
                    margin-left: 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #ffffff;
                    color: #4a596a;
                    border: 1px solid #e4e7ed;
                    padding: 0px;
                    margin-left: 2px;
                    border-radius: 3px;
                    height: 28px;
                    width: 28px;
                    font-size: 13px;
                    cursor: pointer;
                    width: -webkit-fill-available;
                }
            }
        }
    }
}

.placeholder {
    color: rgb(187, 187, 187);
}
</style>